var _circle, _circle2, _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#DADADA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#DADADA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12.6316,
    height: 12.6316,
    transform: "translate(3.68359 3.68359)",
    fill: "#DADADA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6444 9.99866L13.5457 7.09735C13.7299 6.91314 13.7299 6.63682 13.5457 6.45261C13.3615 6.2684 13.0852 6.2684 12.901 6.45261L9.99964 9.35393L7.09832 6.45261C6.91411 6.2684 6.6378 6.2684 6.45359 6.45261C6.26938 6.63682 6.26938 6.91314 6.45359 7.09735L9.3549 9.99866L6.45359 12.9C6.36148 12.9921 6.31543 13.0842 6.31543 13.2223C6.31543 13.4987 6.49964 13.6829 6.77596 13.6829C6.91411 13.6829 7.00622 13.6368 7.09832 13.5447L9.99964 10.6434L12.901 13.5447C12.9931 13.6368 13.0852 13.6829 13.2233 13.6829C13.3615 13.6829 13.4536 13.6368 13.5457 13.5447C13.7299 13.3605 13.7299 13.0842 13.5457 12.9L10.6444 9.99866Z",
    fill: "#22252D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.32e1371aa998839646ad54e89e3917f9.svg";
export { ForwardRef as ReactComponent };